import {DrawerProps} from '@mantine/core';
import {useParams} from "react-router-dom";
import {FormDrawer} from "./FormDrawer.tsx";
import {useApplicationProduct} from "../hooks/useApplicationProduct.ts";

export const EditFormDrawer = (props: DrawerProps) => {
    const {productId} = useParams();

    if (typeof productId === 'undefined') {
        throw new Error('productId is required parameter');
    }

    const {
        record,
        updateRecord,
    } = useApplicationProduct(productId);

    if (!record) return null;

    return (
        <FormDrawer
            record={record}
            handleSubmit={updateRecord}
            {...props}
        />
    )
};
